const STORAGE_KEY = 'wats_post_login_redirect';
const ALLOWED_PREFIXES = ['/register'];

const isAllowedPath = (path) =>
  typeof path === 'string' && ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

export const setPostLoginRedirect = (path) => {
  if (!isAllowedPath(path)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch (error) {
    console.error('Failed to store post-login redirect', error);
  }
};

export const peekPostLoginRedirect = () => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return isAllowedPath(stored) ? stored : null;
  } catch (error) {
    return null;
  }
};

export const consumePostLoginRedirect = (fallback = '/manage/appointments') => {
  const stored = peekPostLoginRedirect();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // ignore
  }
  return stored || fallback;
};

export const captureRedirectFromSearch = (search) => {
  try {
    const params = new URLSearchParams(search || window.location.search);
    const redirect = params.get('redirect');
    if (isAllowedPath(redirect)) {
      setPostLoginRedirect(redirect);
    }
  } catch (error) {
    // ignore
  }
};

export const isBizRegistrationFlow = () => {
  if (typeof window === 'undefined') return false;
  const path = window.location.pathname;
  if (path === '/register' || path.startsWith('/register/')) return true;
  const params = new URLSearchParams(window.location.search);
  const redirect = params.get('redirect');
  if (isAllowedPath(redirect)) return true;
  return Boolean(peekPostLoginRedirect());
};
